import './device-filter.css'

/**
 * Pastila "Device: DC01 x" de pe Detections, Incidents si EDR events cand
 * lista vine dintr-o legatura spre aparat (`?device=`). Numele vine din randuri;
 * fara randuri ramane numarul aparatului. x intoarce lista tuturor aparatelor.
 */
export function DeviceFilterChip({ id, name, onClear, label = 'Device', clearTitle = 'Show all devices' }: { id: number; name?: string; onClear?(): void; label?: string; clearTitle?: string }) {
  return (
    <div className="xdr-device-filter" role="group" aria-label={`${label} filter`}>
      <span className="xdr-device-filter-label">{label}</span>
      <strong className="xdr-device-filter-name">{name || `#${id}`}</strong>
      {onClear && (
        <button type="button" className="xdr-device-filter-clear" title={clearTitle} onClick={onClear}>
          <span aria-hidden="true">×</span>
          <span className="sr-only">{clearTitle}</span>
        </button>
      )}
    </div>
  )
}
